// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: 'b148ea13-f298-4b2d-8aca-bcb60320b451',
      type: 'Container',
      runtimeType: null,
      name: 'progressContainer',
      className: '',
      x: 174,
      y: 3,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          x: {
            value: 'WIDTH * 0.5',
            clamp: {
              min: 427
            }
          }
        }
      },
      stateByName: {}
    },
    {
      id: 'ce914800-8191-43af-b5e8-5b192b379143',
      type: 'Container',
      runtimeType: null,
      name: 'progressBarSlot',
      className: '',
      x: -140,
      y: 3,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b148ea13-f298-4b2d-8aca-bcb60320b451',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'b13899a6-916f-4af8-ada6-453e3f3d32d7',
      type: 'Text',
      runtimeType: null,
      name: 'countText',
      className: '',
      x: 13,
      y: 40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '9999/9999',
      localize: false,
      maxWidth: 220,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '0x870066',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b148ea13-f298-4b2d-8aca-bcb60320b451',
      data: undefined,
      stateByName: {}
    },
    {
      id: '1cde354e-8d5b-464a-bc63-a87f193476ae',
      type: 'Sprite',
      runtimeType: null,
      name: 'icon',
      className: '',
      x: -140,
      y: 37,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'icon',
      parent: 'b148ea13-f298-4b2d-8aca-bcb60320b451',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class ProgressTaskLayout {
  static raw = raw;
  root: Container;
  progressContainer: Container & { data: typeof raw['list'][1]['data'] };
  progressBarSlot: Container;
  countText: Text;
  icon: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      progressContainer: typeof raw['list'][1];
      progressBarSlot: typeof raw['list'][2];
      countText: typeof raw['list'][3];
      icon: typeof raw['list'][4];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
